<script lang="ts">
export default {
  name: 'Badge',
};
</script>

<script setup lang="ts">
const props = defineProps<{
  color?: string;
}>();
</script>

<template>
  <div class="tw:badge tw:badge-outline tw:border
              tw:h-fit tw:w-fit tw:bg-white
              tw:text-nowrap tw:text-center tw:text-xs"
       :class="props.color? '' : 'tw:border-primary tw:text-primary'"
       :style="props.color ? `color: ${props.color}` : ''"
  >
    <slot></slot>
  </div>
</template>
